import angular from "angular";

angular
    .module('app')
    .component('chapterForm', {
        template: require('./chapter-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier) {

    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.title = null;
    $ctrl.description = null;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        if ($ctrl.resolve.chapter) {
            $ctrl.id = $ctrl.resolve.chapter.id;
            $ctrl.title = $ctrl.resolve.chapter.title;
            $ctrl.description = $ctrl.resolve.chapter.description;
        }
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let req = null;

        let params = {course_id: $ctrl.course.id, title: $ctrl.title, description: $ctrl.description};

        if ($ctrl.id) {
            params['_method'] = 'PUT';
            req = $http.post(`/admin/courses/${$ctrl.course.id}/chapters/${$ctrl.id}`, params);
        } else {
            req = $http.post(`/admin/courses/${$ctrl.course.id}/chapters`, params);
        }

        req.then(
            function (response) {
                if (!$ctrl.id) {
                    $ctrl.id = response.data.id;
                    Notifier.success('Глава создана', 2);
                } else {
                    Notifier.success('Глава обновлена', 2);
                    $ctrl.loading = false;
                }
                $ctrl.close({$value: {id: $ctrl.id, title: $ctrl.title, description: $ctrl.description}});
            },
            function (error) {
                ErrorResponseParser.parse(error);
            }
        );
    };


}
